var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.6 81.3C163 67 179.9 60.4 195 65.9L320 111.5L445 65.9C460.1 60.4 477 67 484.4 81.3L563.2 234.2C592 290 573.5 356.5 524.7 390.8L556 477L597 462C613.6 456 632 464.5 638 481.1C644 497.7 635.5 516.1 618.9 522.1C571.5 539.4 524.1 556.6 476.7 573.9C460.1 580 441.7 571.4 435.7 554.8C429.7 538.2 438.2 519.8 454.8 513.8L495.8 498.8L464.5 412.6C405.1 417.8 348.3 378.7 334.5 317.4L319.9 252.7L305.3 317.4C291.5 378.7 234.7 417.8 175.3 412.6L144 498.8L185 513.8C201.6 519.9 210.2 538.2 204.1 554.8C198 571.4 179.7 580 163.1 573.9C115.7 556.6 68.3 539.3 20.9 522.1C4.3 516-4.3 497.7 1.8 481.1C7.9 464.5 26.3 456 42.9 462L83.9 477L115.2 390.8C66.5 356.5 48.1 290 76.9 234.2L155.6 81.3zM199.6 135.7L172.4 188.5L261.6 221L274.7 163.1L199.6 135.7zM440.5 135.7L365.4 163.1L378.5 221L467.7 188.5L440.5 135.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/glass.41db5bc89cf9cb90170eb6588bd699f5.svg";
export { ForwardRef as ReactComponent };